import axios from "axios";

const fallbackApiUrl = "https://dev-api.aniyadak.ir/api";

const runtimeApiUrl =
  window.APP_CONFIG && window.APP_CONFIG.API_BASE_URL
    ? window.APP_CONFIG.API_BASE_URL
    : fallbackApiUrl;

export const baseURL = runtimeApiUrl;

console.log("API base URL:", baseURL);

const AUTH_TOKEN = localStorage.getItem("access_token");

export default axios.create({
  baseURL,
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
    Authorization: `bearer ${AUTH_TOKEN}`,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Access-Control-Allow-Credentials": true,
  },
});